import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setDay } from 'cogsworth/utils/store'
import InputSelect from 'cogsworth/components/BookingForm/Inputs/Select/Select'
import InputSelectMulti from 'cogsworth/components/BookingForm/Inputs/SelectMulti/SelectMulti'
import InputText from 'cogsworth/components/BookingForm/Inputs/Text/Text'
import InputPhone from 'cogsworth/components/BookingForm/Inputs/Phone/Phone'
import InputDate from 'cogsworth/components/BookingForm/Inputs/Date/Date'
import InputCustomDate from 'cogsworth/components/BookingForm/Inputs/CustomDate/CustomDate'
import InputGoogleMapsAddress from 'cogsworth/components/BookingForm/Inputs/GoogleMapsAddress/GoogleMapsAddress'
import InputGuests from 'cogsworth/components/BookingForm/Inputs/Guests/Guests'
import { getFieldQuestion } from 'cogsworth/utils/fields'
import { translate } from "react-i18next"
import { EMAIL_REGEX } from 'cogsworth/constants'
import './Step.css'

const sanitizeHtml = require('sanitize-html')


class BookingFormStep extends Component {
  constructor(props){
    super(props)

    this.state = {
      animation: '',
      innerDivClass: '',
      customTitle: null
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.getInputElement = this.getInputElement.bind(this)
    this.setInnerDivClass = this.setInnerDivClass.bind(this)
    this.setCustomTitle = this.setCustomTitle.bind(this)
    this.goBack = this.goBack.bind(this)
  }

  handleSubmit(value){
    const { field } = this.props
    this.props.onSubmit(field.id, value)
  }

  getInputElement(field){
    const { t } = this.props

    const { bookingTemplatesHtml } = this.props.business
    const okButtonLabel = bookingTemplatesHtml && bookingTemplatesHtml['ok-button'] ? sanitizeHtml(bookingTemplatesHtml['ok-button'], { allowedTags: [] }) : t('ok')
    const inputProps = {
      id: field.id,
      okButtonLabel,
      value: field.value,
      required: field.required,
      onSubmit: this.handleSubmit,
      showFilter: this.props.business.showDropdownFilter,
      options: field.options,
      business: this.props.business,
    }
    switch(field.type) {
      case 'select':
        if (field.isMultiple) {
          return <InputSelectMulti {...inputProps} />
        }
        return <InputSelect {...inputProps} />
      case 'name':
      case 'text':
        return <InputText {...inputProps} />
      case 'email':
        return (
          <InputText
            {...inputProps}
            regex={EMAIL_REGEX}
            invalidMessage="Please enter a valid email address"
          />
        )
      case 'custom-date':
        return (
          <InputCustomDate
            {...inputProps}
            dateFormat={this.props.business.dateFormat.date}
          />
        )
      case 'date':
        return (
          <InputDate
            {...inputProps}
            fieldsToAppointment={this.props.fieldsToAppointment}
            setInnerDivClass={this.setInnerDivClass}
            setCustomTitle={this.setCustomTitle}
            rescheduling={this.props.rescheduling}
            fields={this.props.fields}
          />
        )
      case 'bool':
        return (
          <InputSelect
            {...inputProps}
            options={[{id: 'yes', name: t('yes')}, {id: 'no', name: t('no')}]}
          />
        )
      case 'phone':
        return (
          <InputPhone
            {...inputProps}
            invalidMessage="Please enter a valid phone number"
            countryCode={this.props.countryCode}
          />
        )
      case 'number':
        return (
          <InputText
            {...inputProps}
            regex={/^\d+$/}
            invalidMessage="Please enter a valid number"
          />
        )
      case 'google-maps-address':
        return (
          <InputGoogleMapsAddress
            {...inputProps}
            invalidMessage="Please enter a valid address"
          />
        )
      case 'guests':
        return <InputGuests {...inputProps} />
      default:
        return null
    }
  }

  setCustomTitle(title){
    this.setState({
      customTitle: title
    })
  }

  setInnerDivClass(innerDivClass){
    this.setState({
      innerDivClass
    })
  }

  renderDescription() {
    if (!this.props.field.description) {
      return null
    }

    return (
      <small className="description">{ this.props.field.description }</small>
    )
  }

  goBack() {
    const allowsDaySelection = this.props.state.page && this.props.state.page.booking_date ? false : true
    if (
      this.props.field &&
      this.props.field.id === 'booking_date' &&
      this.props.state.day !== null &&
      allowsDaySelection
    ) {
      this.props.dispatch(setDay(null))
      return
    }

    if (this.props.goBack) {
      this.props.goBack()
    }
  }

  render() {
    const { field, goBack } = this.props

    return (
      <div className={`booking-step booking-step-${field.type} ${this.props.leavingStep ? 'leaving' : 'entering'}`}>
        <div className={`inner ${this.state.innerDivClass}`}>
          <div className="header">
            { goBack && <button className="go-back fa fa-long-arrow-left" onClick={this.goBack}></button> }
            { this.props.title }
            { !this.state.customTitle && <h2>{ getFieldQuestion(field, this.props.fields) }</h2> }
            { this.state.customTitle && <h2>{ this.state.customTitle }</h2> }
            { this.renderDescription() }
          </div>
          <div className="input">
            { this.getInputElement(field) }
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  state: {
    day: state.day,
    page: state.page,
  },
})
export default connect(mapStateToProps)(translate("translations")(BookingFormStep))
